import Link from 'next/link';

interface SocialButtonProps {
  href: string;
  icon: React.ReactNode; // or specify the type of icon
  bgColor?: string;
  size?: string;
  iconSize?: string;
}

const SocialButton = ({
  href,
  icon,
  bgColor = 'bg-gray-800',
  size = 'w-5 h-5',
  iconSize = 'text-sm'
}: SocialButtonProps) => {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`
        ${bgColor}
        ${size}
        rounded-full
        flex
        items-center
        justify-center
        text-white
        hover:opacity-80
        transition-opacity
        duration-200
      `}
    >
      <span className='w-5 h-5' >
        <img src={`${icon}`}/>
      </span>
    </Link>
  );
};

export default SocialButton;
